
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ipfs",
      function () {
        return require("private-next-pages/ipfs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ipfs"])
      });
    }
  